<template>
  <div class="service-task-item">
    <div class="service-task-item__inner-container">
      <v-icon>mdi-wrench</v-icon>
      <p class="service-task-item__text">{{ name }}</p>
      <BaseTextButton prependIcon="mdi-plus" :disabled="isAdded" @click="emitAddServiceItem">Dodaj</BaseTextButton>
    </div>
    <AlertInfo class="mb-0" v-if="isAdded">
      Usługa została już dodana do serwisu. Edytuj ją, jeśli chcesz dokonać zmian.
    </AlertInfo>
  </div>
</template>

<script>
import BaseTextButton from '@/component/Base/base-text-button';
import AlertInfo from '@/component/Alert/alert-info';

export default {
  name: 'ServiceTaskItem',
  components: {
    BaseTextButton,
    AlertInfo,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    isAdded: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    emitAddServiceItem() {
      this.$emit('addServiceItem');
    },
  },
};
</script>

<style lang="scss" scoped>
.service-task-item {
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  gap: 8px;
  background: #ffffff;
  /* Divider */
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  &__inner-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  &__text {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.87);
    flex-grow: 1;

    margin: 0;
  }
}
</style>
